import React from 'react';
import { Home, Menu, Share } from 'lucide-react';

interface NavigationProps {
  onHomeClick: () => void;
  onMenuClick: () => void;
  onShareClick: () => void;
}

export function Navigation({ onHomeClick, onMenuClick, onShareClick }: NavigationProps) {
  return (
    <nav className="w-full max-w-[400px] bg-white shadow-lg">
      <div className="flex justify-around items-center h-16 relative">
        <button onClick={onHomeClick} className="flex flex-col items-center text-gray-600">
          <Home className="h-5 w-5" />
          <span className="text-xs mt-1">Inicio</span>
        </button>
        
        <button onClick={onMenuClick} className="flex flex-col items-center">
          <div className="bg-primary rounded-full w-12 h-12 flex items-center justify-center absolute -top-5 left-1/2 -translate-x-1/2">
            <Menu className="h-5 w-5 text-white" />
          </div>
        </button>
        
        <button onClick={onShareClick} className="flex flex-col items-center text-gray-600">
          <Share className="h-5 w-5" />
          <span className="text-xs mt-1">Compartir</span>
        </button>
      </div>
    </nav>
  );
}